import RootStoreContext from '~/contexts/RootStoreContext';
import async from '~/utils/async';
import resolver from './EditCustomPageLayout.resolver';
import EditCustomPageLayout from './EditCustomPageLayout';

export default async(resolver, { context: RootStoreContext })(
  EditCustomPageLayout
);
